import { useDeleteUOM } from "http-hooks/uom/useUOM";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteUOM({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteUOM();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete unit of measure"
      description="Are you sure you want to delete this unit of measure? This unit of measure will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
